/**
 * 26spring 模块 - 新春活动相关状态管理
 * 用于管理美国本地卡(USLC)老用户信息及页面状态
 */
import { setStore, getStore } from '@/utils/store';

const spring26 = {
  namespaced: true,
  state: {
    // 老用户信息（从本地存储读取，如果不存在则为 null）
    uslcOldUserInfo: getStore({ name: 'uslcOldUser' }) || null,
    // 当前页面类型（从本地存储读取，如果不存在则默认为 'uslcOldUser'）
    isPage: getStore({ name: 'isPage' }) || 'uslcOldUser'
  },
  mutations: {
    /**
     * 设置老用户信息
     * @param {Object} state - 状态对象
     * @param {Object} uslcOldUserInfo - 老用户数据
     */
    SET_USLC_OLD_USER: (state, uslcOldUserInfo) => {
      state.uslcOldUserInfo = uslcOldUserInfo;
      setStore({ name: 'uslcOldUser', content: state.uslcOldUserInfo });
    },
    /**
     * 清除老用户信息
     * @param {Object} state - 状态对象
     */
    CLEAR_USLC_OLD_USER: (state) => {
      state.uslcOldUserInfo = null;
      setStore({ name: 'uslcOldUser', content: null });
    },
    /**
     * 设置当前页面类型
     * @param {Object} state - 状态对象
     * @param {String} isPage - 页面类型标识
     */
    SET_IS_PAGE: (state, isPage) => {
      state.isPage = isPage;
      setStore({ name: 'isPage', content: state.isPage });
    }
  },
  actions: {
    /**
     * 设置老用户信息
     * @param {Function} commit - commit 方法
     * @param {Object} uslcOldUserInfo - 老用户数据
     */
    setUslcOldUser({ commit }, uslcOldUserInfo) {
      commit('SET_USLC_OLD_USER', uslcOldUserInfo);
    },
    /**
     * 清除老用户信息
     * @param {Function} commit - commit 方法
     */
    clearUslcOldUser({ commit }) {
      commit('CLEAR_USLC_OLD_USER');
    },
    /**
     * 设置当前页面类型
     * @param {Function} commit - commit 方法
     * @param {String} isPage - 页面类型标识
     */
    setIsPage({ commit }, isPage) {
      commit('SET_IS_PAGE', isPage);
    }
  }
};

export default spring26;
